import React, { useMemo } from 'react';

import { useResponsive } from '@sg/garnish';

import { Navbar } from '../../../../../components';
import {
  CONTENT_WITH_BG_COLOR_STYLES,
  CONTENT_WITHOUT_BG_STYLES,
  DEFAULT_SCREEN_OPTIONS,
  type ScreenOptions,
  type ScreenOptionsMap,
} from '../../../../constants';

// ─────────────────────────────────────────────────────────────────────────────

export const useTabStackOptions = () => {
  const { match } = useResponsive();

  return useMemo(() => {
    return {
      //
      // ─── Main Stack Options (applied to all screens) ─────────────────────

      Stack: { ...DEFAULT_SCREEN_OPTIONS, headerShown: false },

      // ─── Individual Tabs ─────────────────────────────────────────────────

      Tabs: { ...DEFAULT_SCREEN_OPTIONS },
      Modals: {
        presentation: match(['modal', 'transparentModal']),
        contentStyle: match([CONTENT_WITH_BG_COLOR_STYLES, CONTENT_WITHOUT_BG_STYLES]),
      },
      Auth: { ...DEFAULT_SCREEN_OPTIONS, presentation: 'modal' },

      // ─── Not Found ─────────────────────────────────────────────────────

      NotFound: {
        ...DEFAULT_SCREEN_OPTIONS,
        headerShown: match([false, true]),
        header: match([undefined, renderNavbar]),
      },
    } satisfies TabStackOptionsMap;
  }, [match]);
};

// ─── Helpers ──────────────────────────────────────────────────────────────────

function renderNavbar() {
  return <Navbar />;
}

// ─── Types ───────────────────────────────────────────────────────────────────

type ScreenOptionsCallback = () => ScreenOptions;
type TabStackOptionsMap = Record<string, ScreenOptionsMap[string] | ScreenOptionsCallback>;
